<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-check form-row mx-1">
    <input *ngIf="! afficherEnLectureSeule" (keyup)="scroll(target)" bisKeypadNavigation type="checkbox" [readOnly]="afficherEnLectureSeule"
    [formControlName]="label" class="form-check-input" [id]="idHtml">
    <!-- Pour l’affichage en consultation, utilisation des icônes
          Les cases à cocher restent cliquable en readonly
    -->
    <mat-icon *ngIf="afficherEnLectureSeule && ! currentControl.value">crop_square</mat-icon>
    <mat-icon *ngIf="afficherEnLectureSeule && currentControl.value">done</mat-icon>
    <label class="form-check-label" [for]="idHtml">{{libelle$ | async}}</label>
    <bis-affiche-erreurs *ngIf="erreursAffichable()" class="col-12" [erreurs]="rootForm.get(label).errors"></bis-affiche-erreurs>
    <div #target></div>
  </div>
</form>